//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Validate.js";
import "../no/Builder.js";
import "../GeometricUtilities/GeometricUtilities.DisplayResolutionBuilder.js";
import "../Validate/Validate.SelectionAndPlacementBuilder.js";
import "../no/ugmath.js";
import "../no/GeometricUtilities.js";
let d=[[[0,"AutomaticUpdate",1,0],[0,"CurvatureType",1,0],[1,"DisplayResolutionBuilder",0,"GeometricUtilities.DisplayResolutionBuilder",0],[0,"ExcludeConvex",1,0],[0,"FailureArea",0,0],[0,"LessThanMinimumRadiusColor",1,0],[0,"MinimumRadius",1,0],[0,"MoreThanMinimumRadiusColor",1,0],[0,"PreviewState",1,0],[1,"SelectionAndPlacement",0,"Validate.SelectionAndPlacementBuilder",0],[0,"ShowOnlyFailArea",1,0]],[[["selectedFace","dynamicPnt"],"GetDynamicResult",{R_:{minimumRadius:''}},2,0]],[]];
SPLM.Validate.CheckMinimumRadiusBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Validate.CheckMinimumRadiusBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Validate.CheckMinimumRadiusBuilder.CurvatureTypes = Object.freeze({
    "Radius" : "Radius", "Sectional" : "Sectional"});

export default SPLM;